import { c as _c } from "react/compiler-runtime";
import { CalendarX } from '@phosphor-icons/react';
export function AppCartNoDates() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="mb-5 text-center font-heading3 sm:mb-12">Dieses Erlebnis ist sehr beliebt.</h3>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="fluid-container mt-8 sm:mt-0">{t0}<div className="flex flex-col items-center pt-6 sm:items-start sm:pt-0"><div className="mb-6 flex flex-col items-center space-y-6 sm:mb-8 sm:flex-row sm:items-start sm:space-x-6 sm:space-y-0"><div><CalendarX size={32} /></div><p className="text-center font-body-copy sm:pr-6 sm:text-left">Leider gibt es keine Termine für deine gewünschte Anzahl an Plätzen. Versuche gern eine neue Anfrage indem du die Anzahl an Personen reduzierst.</p></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}